import { AccountMusicOutlineIcon } from './AccountMusicOutlineIcon';

/**
 * author: GreenTurtwig
 * id A8CC9CFF-A5DE-4FC8-A4AC-BCE153F767F8
 * name account-music-outline
 * version: 3.3.92
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-music-outline.svg
 * tags
 * - Account / User 
 */
export const ArtistOutlineIcon = AccountMusicOutlineIcon;
export default ArtistOutlineIcon